import CircularProgress from "@mui/material/CircularProgress";

import { colors } from "@dotnet/telematics-design-system";

const Loader = () => {
    const { blue300, blue700 } = colors;

    return (
        <>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient
                        id="my_gradient"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                    >
                        <stop offset="0%" stopColor={blue700} />
                        <stop offset="100%" stopColor={blue300} />
                    </linearGradient>
                </defs>
            </svg>

            <CircularProgress
                size={16}
                sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
            />
        </>
    );
};

export default Loader;
